import { aesUtil } from './encryption'
import state from '../store/state'
import axios from 'axios'
import Qs from 'qs'
var sec = '48a0088cb506e6b7'
var aaa = sec.split('').reverse().join('')
var bbb = sec.substr(1) + sec.substr(0, 1)

// post请求封装
var postHttp = function (json, url, callback) {
  console.log(json, url)
  var data = Qs.stringify(request_data(json))
  axios.post(url, data)
    .then(response => {
      if (JSON.stringify(response).search("resp=") !== -1) {
        let newdata = JSON.stringify(response.data).split('&')[0].substr(6)
        let decdata = aesUtil.decrypt(decodeURIComponent(newdata), bbb)
        callback(decdata)
      } else {
        console.log(response)
        console.log('请求异常')
        return '异常'
      }
    }).catch(error => {
      console.log('请求异常error', error)
    })
}
// get请求封装
var getHttp = function (obj, url, callback) {
  axios.post(url, request_data(obj))
    .then(response => {
      if (JSON.stringify(response).search("resp=") !== -1) {
        let newdata = JSON.stringify(response).split('&')[0].substr(6)
        let decdata = aesUtil.decrypt(decodeURIComponent(newdata), bbb)
        // console.log('请求参数',json)
        // console.log('请求路由',url)
        // console.log('请求响应',decdata)
        callback(decdata)
      } else {
        console.log(data)
        console.log('请求异常')
        return '异常'
      }
    }).catch(error => {
      console.log('请求路由', url)
      console.log('请求连接异常', error)
    })
}
// 接口通用参数传参处理
var request_data = function (obj) {
  let json_data = {
    qd: localStorage.getItem("qd"),//渠道号
    ver: '000001',//版本号
    uid: state.uid,//uid
    origin: '0',// 请求来源：pc
  };
  if (obj != null) {
    for (var keyObj in obj) {
      if (obj.hasOwnProperty(keyObj) === true) {
        json_data[keyObj] = obj[keyObj];
      }
    }
  }
  let data = aesUtil.encrypt(JSON.stringify(json_data), aaa)
  let proce_data = {
    req: data,
    sec: sec
  }
  return proce_data
}
var postData = function (json) {
  return Qs.stringify(request_data(json))
}
export default {
  postHttp,
  getHttp,
  request_data,
  postData
}



// WEBPACK FOOTER //
// ./src/utils/request.js